<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        title="State Inventory"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'reports', label: 'Reports' },
          { name: 'stateInventory', label: 'State Inventory' },
        ]"
        :pageHeader="listPageHeader"
        :entity="entity"
        :hideAddButton="true"
        @export="exportInCSV"
        :disableExport="isLoading"
      >

        <Button v-if="showFinishPackages" @click="toggleModal" style="text-transform: capitalize;" :colorType="2">
          Finish Packages
        </Button>

      </PageHeader>
      <br class="no-print" />
      <div>
        <StateInventoryList @rowsLoaded="rowsLoaded" />
      </div>
    </div>
    <BaseModal
      v-if="isModalOpen"
      @toggle-modal="toggleModal"
      title="Finish Packages"
    >
      <div class="stateInventoryModal">
        <div class="label">
          We found {{ itemsToFinish.length }} package(s) ready to be finished. Please review the list below and click "Finish Packages" - the report will automatically refresh once complete.
        </div>
        <div class="packages">
          <div class="package" v-for="item in itemsToFinish" :key="item.batchId">
            <div class="package__name">
              {{ item.batchId }}
            </div>
            <div class="gray-text">
              DF: {{ item.dfQuantity }} - State: {{ item.stateQuantity }}
            </div>
          </div>
        </div>
        <div class="footer">
          <Button  @click="finishBatches" style="text-transform: capitalize;" :colorType="2" :isLoading="loadingStatus.finishPackages">
            Finish Packages
          </Button>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import StateInventoryList from "./components/StateInventoryList.vue";
import moment from "moment";
// import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Entities from "@/resources/Entities";
import _ from "lodash";
import Utilities from "@/lib/Utilities";
import Constants from "@/resources/Constants";
import ReportHelper from "@/lib/report/index.js";
import Button from "@/components/Base/Button/Button.vue";
import BaseModal from "@/components/Modals/BaseModal/BaseModal.vue";

export const listPageHeader = {
  title: "State Inventory",
  isEditorView: false,
  buttonLabel: "New",
  routerPath: "employeeEditor",
};

export default {
  name: "stateInventory",
  data() {
    return {
      moment: moment,
      Constants: Constants,
      Utilities: Utilities,
      listPageHeader,
      entity: Entities.STATEINVENTORY,
      itemsToFinish: [],
      isModalOpen: false,
    };
  },
  components: {
    PageHeader,
    // ReportFilter,
    StateInventoryList,
    BaseModal,
    Button
  },
  created: function () {
    this.setPageTitle("State Inventory");
  },
computed: {
    ...mapGetters({
      currentStore: "storeModule/currentStore",
      loadingStatus: "stateModule/loadingStatus",
      stateInventory: "stateModule/stateInventory",
    }),
    isLoading() {
      return this.loadingStatus.getStateInventory;
    },
    isMetrc() {
      return this.currentStore.traceabilitySystem == "metrc";
    },
    showFinishPackages() {
      return this.isMetrc && this.itemsToFinish.length > 0;
    }
  },
  methods: {
    ...mapActions({
      getStateInventory: "stateModule/getStateInventory",
      finishPackages: "stateModule/finishPackages",
      setMessage: "setMessage",
    }),
    exportInCSV() {
      var table = document.getElementById("state-inventory-table");
      ReportHelper.exportToExcel(table, "StateInventory");
    },
    toggleModal() {
      this.isModalOpen = !this.isModalOpen;
    },
    finishBatches() {
      const positiveCallback = (response) => {
            const {successCount, failedBatchIds} = response

            if(failedBatchIds > 0) {
              this.setMessage({
                title: "Failed to Finish Packages",
                text: `Failed to finish ${failedBatchIds} package(s). The packages may have already been finished or still contain inventory.`,
                type: "state-error"
              });
              return;
            }

            const text = successCount > 0 ? "Finished " + successCount + " Packages!" : "Up to date!";
            this.setMessage({
              isOpen: true,
              text: text,
              type: "success"
            });

            this.getStateInventory();
            this.isModalOpen = false;
        };

        const batchIds = this.itemsToFinish.map(q => q.batchId)
        const body = {
          batchIds: batchIds
        }

        this.finishPackages({positiveCallback, body});
    },
    rowsLoaded(rows) {
      if(rows.length > 0) {
        this.itemsToFinish = rows.filter(q => q.stateQuantity != undefined && q.stateQuantity != undefined && q.dfQuantity === q.stateQuantity)
      }
    },
  },
};
</script>

<style scoped lang="scss">
.stateInventoryModal {
  padding: 1.25rem;
  .label {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .packages {
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow-y: auto;
    max-height: 300px;
  }
  .package {
    display: flex;
    flex-direction: row;
    gap: .5rem;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>